<script setup lang="ts">
const { setHotels } = useHotels();
const travelData = useTravelDataStore();
const { fetchGeoIpLocation } = useGeoIpLocation();

callOnce(async () => {
  setHotels(await $fetch("/api/v2/properties/hotels"));
  await travelData.initPriceType(fetchGeoIpLocation);
});
</script>

<template>
  <div id="app">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
